import React from 'react'
import { CustomerAssignment } from 'models/customer'
import './style.scss'

type Props = {
  data: CustomerAssignment
}

export const CustomerAssignmentDisplay = (props: Props) => {
  return (
    <div className="c-customer-assignment-display">
      <div>
        <span style={{ fontWeight: 400 }}>{props.data.name}</span>
      </div>
    </div>
  )
}

export default CustomerAssignmentDisplay